<!-- =========================================================================================
  File Name: UserList.vue
  Description: User List page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>

  <div id="page-role-list" class="ag-grid-container">

    <div class="vx-card">
      <grid-action-bar
          :showDeleted="false"
          v-on:update:search="searchQuery = $event"
          v-on:update:deleted="showDeleted = $event"
          title="Applications"
      >
        <vs-dropdown-item>
          <span
              v-if="canAccessRoute('application.create')"
              class="flex items-center"
              @click="$router.push({ name: 'application.create' })"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="mr-2" />
            <span>Create Application</span>
          </span>
        </vs-dropdown-item>
      </grid-action-bar>

      <!-- AgGrid Table -->
      <t-grid
          :column-defs="columnDefs"
          class="xl"
          :data="data"
          :loading="loading"
          :auto-size="true"
          :search="searchQuery"
          @rowClicked="onRowClicked"
      />

    </div>
  </div>

</template>

<script>
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import CanAccessMixin from "@/components/mixins/CanAccessMixin";

// Cell Renderer
import TGrid from "@/views/components/ag-grid/TGrid";
import YesNoToggle from "@/views/components/extra-components/YesNoToggle";
import GridActionBar from "@/views/components/extra-components/GridActionBar";
import router from '../../../router';

export default {
  components: {
    TGrid,
    vSelect,
    GridActionBar,
    YesNoToggle,
  },
  mixins: [CanAccessMixin],
  data () {
    return {
      searchQuery: '',
      showDeleted: false,
      // AgGrid
      columnDefs: [
        {
          headerName: 'Application',
          field: 'ApplicationName',
          filter: 'agTextColumnFilter',
        },
      ],

      data: [],
      loading: false,
    }
  },
  watch: {
    showDeleted(value) {
      this.list({IsDeleted: value | 0});
    }
  },
  mounted() {
    this.list();
  },
  methods: {
    updateSearchQuery (val) {
      this.searchQuery = val;
    },
    async onRowClicked({data}) {
      const route = 'application.view';

      if (await this.canAccessRoute(route, false)) {
        this.$router.push({ name: route, params: { id: data.id }}).catch(() => {});
      }
    },
    async list(params = {}) {
      try {
        this.loading = true;
        const { data } = await this.$api.applications.all({ params });
        this.data = data.data;
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
}

</script>

<style lang="scss">
#page-company-list {
  .company-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
